import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initLenis, scrollToTop } from "./lib/scroll";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import About from "./pages/About";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        scrollToTop(true);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        initLenis();
    }, []);

    return (
        <div className="App font-sans">
            <Toaster position="top-center" richColors />
            <BrowserRouter>
                <ScrollManager />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/sobre-mi" element={<About />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
